"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const SvgIcon_vue_1 = __importDefault(require("./SvgIcon/SvgIcon.vue"));
const SharedSpinner_vue_1 = __importDefault(require("./SharedSpinner.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedButton',
    props: {
        variant: { default: "primary" },
        dark: { type: Boolean },
        disabled: { type: Boolean },
        isLoading: { type: Boolean },
        to: {},
        orchestratorLink: { type: Boolean },
        type: { default: "button" },
        prependIcon: {},
        appendIcon: {},
        iconPrefix: { type: Boolean, default: true },
        iconSize: { default: "5" },
        small: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const isDisabled = (0, vue_3.computed)(() => props.disabled || (props.isLoading && !(0, vue_3.useAttrs)()["aria-disabled"]));
        const hasSlot = (0, vue_3.computed)(() => !!(0, vue_3.useSlots)().default);
        const isPrimary = (0, vue_3.computed)(() => props.variant === "primary");
        const isSecondary = (0, vue_3.computed)(() => props.variant === "secondary");
        const isProminent = (0, vue_3.computed)(() => props.variant === "prominent");
        const isPayPal = (0, vue_3.computed)(() => props.variant === "payPal");
        const isText = (0, vue_3.computed)(() => props.variant === "text");
        const isLink = (0, vue_3.computed)(() => props.to || (0, vue_3.useAttrs)().href);
        const dynamicDataTestAttr = (0, vue_3.computed)(() => isLink.value ? "data-test-shared-button-anchor" : "data-test-shared-button");
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(isLink.value ? (_ctx.to ? 'RouterLink' : 'a') : 'button'), (0, vue_2.normalizeProps)({
                class: ["shared-button inline-flex select-none items-center justify-center whitespace-nowrap rounded-full border align-top text-sm font-semibold", {
                        'is-text border-transparent text-black-primary disabled:text-gray-50': isText.value,
                        'is-primary text-white disabled:text-gray-50': isPrimary.value && !_ctx.dark,
                        'is-primary-dark text-black-primary focus-visible:outline-white disabled:text-gray-50': isPrimary.value && _ctx.dark,
                        'is-secondary text-black-primary backdrop-blur-sm disabled:border-gray-30 disabled:text-gray-50': isSecondary.value && !_ctx.dark,
                        'is-secondary-dark backdrop-blur-sm focus-visible:outline-white': isSecondary.value && _ctx.dark,
                        'is-prominent text-white focus-visible:outline-red-primary disabled:text-gray-50': isProminent.value,
                        'is-paypal disabled:text-gray-50': isPayPal.value,
                        'is-disabled': _ctx.isLoading && _ctx.$attrs['aria-disabled'],
                        'px-8': hasSlot.value,
                        'h-11.5': !_ctx.small,
                        'w-11.5': !hasSlot.value && !_ctx.small,
                        'h-8 w-8': !hasSlot.value && _ctx.small,
                    }],
                to: _ctx.to,
                type: !isLink.value ? _ctx.type : undefined,
                disabled: !isLink.value ? isDisabled.value : undefined,
                onclick: isLink.value && _ctx.orchestratorLink ? 'window.ocmOrchestrator?.spaNavigateUrl(event)' : undefined,
                style: { "-webkit-tap-highlight-color": "transparent" },
                [dynamicDataTestAttr.value || ""]: true
            }), {
                default: (0, vue_2.withCtx)(() => [
                    (_ctx.isLoading)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SharedSpinner_vue_1.default, {
                            key: 0,
                            dark: ""
                        }))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                            (_ctx.prependIcon)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SvgIcon_vue_1.default, {
                                    key: 0,
                                    class: (0, vue_2.normalizeClass)(["shrink-0", [`size-${_ctx.iconSize}`, { 'mr-2': hasSlot.value || _ctx.appendIcon }]]),
                                    "icon-name": _ctx.prependIcon,
                                    "icon-prefix": _ctx.iconPrefix
                                }, null, 8, ["class", "icon-name", "icon-prefix"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.renderSlot)(_ctx.$slots, "default"),
                            (_ctx.appendIcon)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SvgIcon_vue_1.default, {
                                    key: 1,
                                    class: (0, vue_2.normalizeClass)(["shrink-0", [`size-${_ctx.iconSize}`, { 'ml-2': hasSlot.value }]]),
                                    "icon-name": _ctx.appendIcon,
                                    "icon-prefix": _ctx.iconPrefix
                                }, null, 8, ["class", "icon-name", "icon-prefix"]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ], 64))
                ]),
                _: 3
            }, 16, ["class", "to", "type", "disabled", "onclick"]));
        };
    }
});
